// URL is the SINGLE SOURCE OF TRUTH for the active project + branch.
// The canonical shape is:  /p/<projectSlug>/b/<branch>/<page...>
// Nothing reads the project/branch from cookies, localStorage, a query param,
// or the JWT — only from the path here. Every /api request derives its
// X-Cortex-Project / X-Cortex-Branch headers from these helpers, and all
// in-app navigation is built through createPageUrl / projectPath so the
// segments are always carried along.

export const DEFAULT_BRANCH = "main";

// Parse { projectSlug, branch, rest } out of a path. rest is the sub-path AFTER
// /p/<slug>/b/<branch> (no leading slash). Missing pieces come back null/"".
export function parseProjectPath(pathname) {
  const parts = (pathname || "").split("/").filter(Boolean); // e.g. ["p","demo","b","main","apps","x"]
  let projectSlug = null;
  let branch = null;
  let restParts = parts;
  if (parts[0] === "p" && parts[1]) {
    projectSlug = decodeURIComponent(parts[1]);
    restParts = parts.slice(2);
    if (restParts[0] === "b" && restParts[1]) {
      branch = decodeURIComponent(restParts[1]);
      restParts = restParts.slice(2);
    }
  }
  return { projectSlug, branch: branch || null, rest: restParts.join("/") };
}

// The active project slug from the current URL (single source of truth).
export function currentProjectSlug() {
  try { return parseProjectPath(window.location.pathname).projectSlug; } catch { return null; }
}

// The active branch from the current URL, defaulting to main.
export function currentBranch() {
  try { return parseProjectPath(window.location.pathname).branch || DEFAULT_BRANCH; } catch { return DEFAULT_BRANCH; }
}

// Build an in-app path for `page` under a given project/branch. If slug/branch
// are omitted, read them from the current URL. `page` may be "" (project root).
export function projectPath(page, { slug, branch } = {}) {
  const s = slug || currentProjectSlug();
  const b = branch || currentBranch();
  const clean = String(page || "").replace(/^\/+/, "");
  if (!s) return "/" + clean; // no project context yet — bare path (redirect guard handles it)
  const base = `/p/${encodeURIComponent(s)}/b/${encodeURIComponent(b)}`;
  return clean ? `${base}/${clean}` : `${base}/dashboard`;
}
